import { ref, onMounted } from '@vue/composition-api'
import { cpRequestUseCase } from '../../usecases'
import useRouter from '../useRouter'

const usePartner = () => {

    const campaign = ref()

    const { route } = useRouter();

    onMounted(async () => {
        
        const partnerId = route.value.query.project_id
        if (!partnerId) {
            return
        }

        try {
            campaign.value = await cpRequestUseCase.getPartnerData(partnerId) 
        } catch(err) {
            console.log(err)
        }

    })

    return {
        campaign
    }
}

export default usePartner